import get from 'lodash/get';

import { GET_USER_OFFER_RESPONSE } from 'actions/userOffers';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_OFFER_RESPONSE:
      return {
        ...state,
        ...(action.response.userOffer.eventType && {
          [action.response.userOffer.eventType]: action.response.userOffer,
        }),
      };
    default:
      return state;
  }
};

export const selectUserOffers = state => get(state, 'userOffers');
export const selectUserOffer = (state, eventType) => get(selectUserOffers(state), eventType);
